import React, { FC, useEffect, useRef } from 'react';

/** First-game primer shown once to players with zero games played. */
export const TutorialOverlay: FC<{ onDismiss: () => void }> = ({
  onDismiss,
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    buttonRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onDismiss();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onDismiss]);

  return (
    <div className="bh-modal">
      <div
        className="st-card"
        data-suit="spades"
        role="dialog"
        aria-modal="true"
        aria-labelledby="tutorial-title"
      >
        <div className="bh-stack" style={{ ['--bh-gap' as string]: '16px' }}>
          <p className="st-eyebrow">First game?</p>
          <h2 id="tutorial-title" className="st-h2">
            Don&apos;t be the <em>Bhabi.</em>
          </h2>
          <ul className="bh-checklist">
            <li>
              <span className="bh-checklist__glyph" aria-hidden="true">
                ♠
              </span>
              <span>
                Whoever holds the <strong>Ace of Spades</strong> leads first.
              </span>
            </li>
            <li>
              <span
                className="bh-checklist__glyph"
                data-red="true"
                aria-hidden="true"
              >
                ♥
              </span>
              <span>
                <strong>Follow the suit</strong> if you can. If you can&apos;t,
                play any card — the round&apos;s cards go to the highest player.
              </span>
            </li>
            <li>
              <span className="bh-checklist__glyph" aria-hidden="true">
                ♣
              </span>
              <span>
                <strong>Empty your hand</strong> to escape. The last player
                holding cards is the Bhabi.
              </span>
            </li>
            <li>
              <span
                className="bh-checklist__glyph"
                data-red="true"
                aria-hidden="true"
              >
                ♦
              </span>
              <span>
                Winners take the <strong>coin pool</strong> and every game earns{' '}
                <strong>XP</strong>.
              </span>
            </li>
          </ul>
          <button
            ref={buttonRef}
            type="button"
            onClick={onDismiss}
            className="st-btn st-btn--primary st-btn--block"
          >
            Got it — let&apos;s play
          </button>
        </div>
      </div>
    </div>
  );
};
